// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Defines SpeakerRecognitionModel interface for Speaker Recognition models
 * @interface SpeakerRecognitionModel
 */
export interface SpeakerRecognitionModel {
    scenario: string;
    profileIds: string[];
}
